import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = {
  key: 0,
  class: "information-container"
}
const _hoisted_3 = { class: "empty-text" }
const _hoisted_4 = { class: "card-footer" }

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import GraphIcon from '@/design-system/assets/icons/IconTimeLine.vue'
import InfoIcon from '@/design-system/assets/icons/IconInfoCircle.vue'
import FullScreenOpenIcon from '@/design-system/assets/icons/IconMaximize2.vue'
import FullScreenCloseIcon from '@/design-system/assets/icons/IconMinimize2.vue'
import { ref } from 'vue'
import { CardState } from '../../types'
import MarkDown from '@/components/MarkDown.vue'

type Props = {
  title: string
  hasError?: Error
  state: CardState
  filterMessage: string
  additionalInfo?: string
}

type Emits = {
  (e: 'isPresentingInfo', value: boolean): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GraphCard',
  props: {
    title: {},
    hasError: {},
    state: {},
    filterMessage: {},
    additionalInfo: {}
  },
  emits: ["isPresentingInfo"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const toggleInfo = () => {
  presentInformation.value = !presentInformation.value
  emit('isPresentingInfo', presentInformation.value)
}
const toggleFullscreen = () => {
  presentFullscreen.value = !presentFullscreen.value
  componentKey++
}
const presentInformation = ref(false)
const presentFullscreen = ref(false)
let componentKey = 0


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["container", { fullscreen: presentFullscreen.value }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
        (_ctx.additionalInfo)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "info-button",
              onClick: toggleInfo
            }, [
              (presentInformation.value)
                ? (_openBlock(), _createBlock(GraphIcon, {
                    key: 0,
                    class: "icon"
                  }))
                : (_openBlock(), _createBlock(InfoIcon, {
                    key: 1,
                    class: "icon"
                  }))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "fullscreen-button",
          onClick: toggleFullscreen
        }, [
          (!presentFullscreen.value)
            ? (_openBlock(), _createBlock(FullScreenOpenIcon, {
                key: 0,
                class: "icon"
              }))
            : (_openBlock(), _createBlock(FullScreenCloseIcon, {
                key: 1,
                class: "icon"
              }))
        ])
      ]),
      (presentInformation.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.additionalInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(MarkDown, { source: _ctx.additionalInfo }, null, 8, ["source"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", {
            key: _unref(componentKey),
            class: "content-container"
          }, [
            (_ctx.state === 'LOADING')
              ? _renderSlot(_ctx.$slots, "loading", { key: 0 }, () => [
                  _createVNode(PulseLoader, {
                    loading: true,
                    color: "#3F46D6"
                  })
                ])
              : (_ctx.hasError)
                ? _renderSlot(_ctx.$slots, "error", { key: 1 }, () => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.hasError.message), 1)
                  ])
                : (_ctx.state === 'EMPTY' || _ctx.state === 'DISABLED')
                  ? _renderSlot(_ctx.$slots, "empty", { key: 2 }, () => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.filterMessage), 1)
                    ])
                  : _renderSlot(_ctx.$slots, "default", { key: 3 })
          ])),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "footer")
      ])
    ], 2),
    (presentFullscreen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overlay",
          onClick: toggleFullscreen
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})